import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const MailBase = (
  <path
    fill='currentColor'
    d='M3 17.338c0 .365.312.662.695.662h16.61c.384 0 .695-.297.695-.662V6.662c0-.365-.312-.662-.695-.662H3.695C3.31 6 3 6.297 3 6.662v10.676zm9.299-4.107c-.165.093-.431.094-.598 0L4.385 9.113V7.4l7.316 4.118c.165.093.431.093.598 0l7.316-4.118v1.714L12.3 13.231z'
  />
)

export const Mail = createIcon({
  displayName: 'Mail',
  viewBox: '0 0 24 24',
  path: MailBase,
})
